module.exports = __webpack_public_path__ + "static/media/808-hat-01.b5922c54.wav";